(() => {
  if (window.NickmicsGiftMilestones) return;
  window.NickmicsGiftMilestones = true;

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const TIERS = [139900, 189900, 259900];
  let syncing = false;
  let lastSignature = '';

  const request = async (path, body) => {
    const response = await fetch(ROOT + path, {
      method: body ? 'POST' : 'GET',
      headers: {'Accept':'application/json', ...(body ? {'Content-Type':'application/json'} : {})},
      body: body ? JSON.stringify(body) : undefined
    });
    if (!response.ok) throw new Error((await response.text()) || `Cart error ${response.status}`);
    return response.json();
  };

  const giftTier = item => Number(item.properties && item.properties._gift_milestone || 0);
  const qualifyingSubtotal = cart => cart.items.reduce((total, item) => giftTier(item) ? total : total + item.final_line_price, 0);
  const money = cents => new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format(cents/100);
  const signature = cart => cart.items.map(i => `${i.key}:${i.quantity}:${i.final_line_price}`).join('|');

  async function addGift(id, tier) {
    return request('cart/add.js', {items:[{id:Number(id),quantity:1,properties:{_gift_milestone:String(tier)}}]});
  }
  async function removeLine(item) { return request('cart/change.js', {id:item.key,quantity:0}); }

  function render(root, cart) {
    const subtotal = qualifyingSubtotal(cart);
    const next = TIERS.find(t => subtotal < t);
    root.querySelector('[data-gift-message]').textContent = next ? `Add products worth ${money(next-subtotal)} to unlock reward` : 'You unlocked all free gifts!';
    const width = subtotal < 139900 ? Math.min(25,subtotal/139900*25) : subtotal < 189900 ? 25+(subtotal-139900)/50000*25 : subtotal < 259900 ? 50+(subtotal-189900)/70000*50 : 100;
    root.querySelector('[data-gift-progress]').style.width = `${Math.max(0,Math.min(100,width))}%`;
    root.querySelectorAll('[data-step]').forEach(dot => dot.classList.toggle('is-unlocked', subtotal >= Number(dot.dataset.step)));
    root.querySelector('[data-choice-tier="189900"]').hidden = subtotal < 189900;
    root.querySelector('[data-choice-tier="259900"]').hidden = subtotal < 259900;
    const selected = new Set(cart.items.filter(giftTier).map(i => String(i.variant_id)));
    root.querySelectorAll('[data-gift-choice]').forEach(button => button.classList.toggle('is-selected', selected.has(String(root.dataset[`${button.dataset.giftChoice}Id`]))));
    const error = root.querySelector('[data-gift-error]'); error.hidden = true; error.textContent = '';
  }

  async function sync(force=false) {
    const roots = [...document.querySelectorAll('[data-gift-milestones]')];
    if (!roots.length || syncing) return;
    syncing = true;
    try {
      let cart = await request('cart.js');
      const sig = signature(cart);
      if (!force && sig === lastSignature) { roots.forEach(r => render(r,cart)); return; }
      lastSignature = sig;
      const subtotal = qualifyingSubtotal(cart);
      let changed = false;

      for (const item of cart.items.filter(giftTier)) {
        if (subtotal < giftTier(item)) { await removeLine(item); changed = true; }
      }
      if (changed) cart = await request('cart.js');

      const root = roots[0];
      const chikkiId = Number(root.dataset.chikkiId);
      const hasChikki = cart.items.some(i => Number(i.variant_id) === chikkiId);
      if (qualifyingSubtotal(cart) >= 139900 && !hasChikki) {
        await addGift(chikkiId,139900); cart = await request('cart.js'); changed = true;
      }

      lastSignature = signature(cart);
      document.querySelectorAll('[data-gift-milestones]').forEach(r => render(r,cart));
      if (changed) document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
    } catch (error) {
      document.querySelectorAll('[data-gift-error]').forEach(box => {box.hidden=false;box.textContent=error.message;});
    } finally { syncing=false; }
  }

  document.addEventListener('click', async event => {
    const button = event.target.closest && event.target.closest('[data-gift-choice]');
    if (!button) return;
    event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation();
    if (button.disabled) return;
    const root = button.closest('[data-gift-milestones]');
    const tier = Number(button.closest('[data-choice-tier]').dataset.choiceTier);
    root.querySelectorAll('[data-gift-choice]').forEach(b => b.disabled=true);
    try {
      let cart = await request('cart.js');
      if (qualifyingSubtotal(cart) < tier) throw new Error('This reward is not unlocked yet.');
      for (const item of cart.items.filter(i => giftTier(i) === tier)) await removeLine(item);
      await addGift(root.dataset[`${button.dataset.giftChoice}Id`],tier);
      await sync(true);
      document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
    } catch(error) {
      const box=root.querySelector('[data-gift-error]');box.hidden=false;box.textContent=error.message;
    } finally { root.querySelectorAll('[data-gift-choice]').forEach(b => b.disabled=false); }
  }, true);

  setInterval(() => sync(false), 700);
  document.addEventListener('DOMContentLoaded', () => sync(true));
})();
